module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-10.8c82c969.jpg";